import React from "react";

import BarChartSvg from "../../assets/images/icons/Form Controls/Bar Chart.svg";

export const BarChartIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={BarChartSvg}
        alt={alt || "BarChart"}
    />
);
